module.exports = __webpack_public_path__ + "img/20200514_151934.fb12990b.jpg";